import { i18n } from '@/locales';
export function setupVueI18n(locale) {
    var _a;
    const lang = locale ? locale.replace('_', '-') : 'en-US';
    i18n.global.locale.value = lang;
    // replace app name here variable name mountAppContext({ microApp }) should match
    if ((_a = window === null || window === void 0 ? void 0 : window.contentAIApp) === null || _a === void 0 ? void 0 : _a.use)
        window.contentAIApp.use(i18n);
}
